import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login"); return; }
    api.get("/orders").then(r => setOrders(r.data)).catch(() => {});
  }, [user, loading, nav]);

  if (!user) return null;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16" data-testid="account-page">
      <div className="grid lg:grid-cols-4 gap-12">
        <aside className="lg:col-span-1">
          <div className="overline text-[#4A1525] mb-4">Welcome</div>
          <h1 className="font-serif text-4xl mb-8">{user.name}</h1>
          <nav className="space-y-3 border-t border-[#E6DED5] pt-6">
            <div className="overline text-[#5C5C5C]">Orders</div>
            <Link to="/wishlist" className="block overline hover:text-[#4A1525]">Favourites</Link>
            {user.is_admin && <Link to="/admin" className="block overline hover:text-[#4A1525]" data-testid="admin-link">Admin</Link>}
            <button onClick={() => { logout(); nav("/"); }} className="overline text-[#7A2020]" data-testid="logout-btn">Sign out</button>
          </nav>
        </aside>
        <section className="lg:col-span-3">
          <h2 className="font-serif text-3xl mb-8">Order history</h2>
          {orders.length === 0 ? (
            <p className="text-[#5C5C5C]" data-testid="no-orders">No orders yet.</p>
          ) : (
            <div className="space-y-4" data-testid="orders-list">
              {orders.map(o => (
                <div key={o.id} className="border border-[#E6DED5] p-6 flex justify-between items-center bg-white">
                  <div>
                    <div className="overline text-[#5C5C5C]">Order · {new Date(o.created_at).toLocaleDateString()}</div>
                    <div className="font-serif text-xl mt-1">₹{o.amount?.toFixed(0)} · {o.items.length} item(s)</div>
                  </div>
                  <div className={`overline px-3 py-1 ${o.payment_status === "paid" ? "bg-[#2D4A22] text-[#FAF8F5]" : "bg-[#F0EBE1] text-[#5C5C5C]"}`}>
                    {o.payment_status}
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
